













































































































































































































































































































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { StudyDummyBaseMethod } from '@/mixins/requests/student/StudyApis.vue'
import { QuestionAnswerType } from '@/mixins/requests/student/StudyApis.vue'

const module4 = require('../../../../public/dummy/study/js/4-module.js')

@Component({})
export default class StudyDummy4 extends Vue implements StudyDummyBaseMethod {
  @Prop()
  currentQuestionAnswer?: QuestionAnswerType

  public getQuestionAnswer(): QuestionAnswerType {
    // 入力値（a〜gの選択値の配列）を取得
    let selectedValues = []
    const alphabet = 'ABCDEF'.split('')
    for (var i = 0; i < alphabet.length; i++) {
      let element = document.getElementById(`${alphabet[i]}-text`) as HTMLElement
      let text = element.textContent || ''
      if (text == alphabet[i].toLowerCase()) text = ''
      selectedValues.push(text)
    }
    return { inputs: selectedValues }
  }

  public restoreInputedElements(): void {
    // 入力値を復元
    if (!this.currentQuestionAnswer || !this.currentQuestionAnswer.inputs) return
    const alphabet = 'ABCDEF'.split('')
    for (var i = 0; i < alphabet.length; i++) {
      const value = this.currentQuestionAnswer.inputs[i]
      if (!value) continue
      module4.restore(alphabet[i], value)
    }
  }

  public clearInputedElements(): void {
    // やり直し
    const alphabet = 'ABCDEF'.split('')
    for (var i = 0; i < alphabet.length; i++) {
      module4.clear(alphabet[i])
    }
  }

  private mounted() {
    let scriptEl = document.createElement('script')
    scriptEl.setAttribute('src', '/dummy/study/js/4.js')
    ;(document.getElementById('contentsarea4') as HTMLElement).appendChild(scriptEl)

    // 入力値を復元
    this.restoreInputedElements()
  }
}
